import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { countries } from "../../constants.js";
import Footer from "../Footer/Footer";
import AppleLocalNav from "../AppleLocalNav";
import Navbar from "../Navbar/Navbar";
import "./Donate.css";

const Donate = () => {
  const [donationFrequency, setDonationFrequency] = useState("Once");
  const [donationAmount, setDonationAmount] = useState("---");
  const [donationArea, setDonationArea] = useState("---");
  const [processingFee, setProcessingFee] = useState("---");
  const [dropdownState, setDropdown] = useState(false);
  const [pan, setPAN] = useState("");
  const [error, setError] = useState("");
  const [customAmount, setCustomAmount] = useState("");
  const [selectedAmount, setSelectedAmount] = useState(null);
  const [slideDirection, setSlideDirection] = useState("forward");
  const [currentStep, setCurrentStep] = useState(0);
  const TOTAL_STEPS = 6;

  const goNext = () => {
    setSlideDirection("forward");
    setCurrentStep((prev) => Math.min(prev + 1, TOTAL_STEPS - 1));
  };

  const goBack = () => {
    setSlideDirection("backward");
    setCurrentStep((prev) => Math.max(prev - 1, 0));
  };

  useEffect(() => {
    const el = document.getElementById(`donate-section-${currentStep + 1}`);
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }, [currentStep]);

  const StepNavigation = ({ showBack, showNext }) => (
    <div className="step-nav">
      {showBack ? (
        <button type="button" className="step-btn" onClick={goBack}>
          Back
        </button>
      ) : <div> </div>}
      {showNext ? (
        <button type="button" className="step-btn" onClick={goNext}>
          Next
        </button>
      ) : <></>}
    </div>
  );


  // For PAN validation
  const validatePAN = () => {
    if (pan === "") {
      setError("");
      return;
    }
    const alphanumericRegex = /^[A-Z]{5}[0-9]{4}[A-Z]$/;
    if (!alphanumericRegex.test(pan)) {
      setError("Please enter valid PAN number.");
    } else {
      setError("");
    }
  };

  // Razorpay Script
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.async = true;
    document.body.appendChild(script);
  }, []);

  // For country dropdown list
  useEffect(() => {
    const selectCountry = document.getElementById("form-donate-country");

    countries.forEach((country) => {
      const option = document.createElement("option");
      option.text = country;
      option.value = country;
      selectCountry.add(option);
    });
  }, []);

  const handleFrequencyChange = (event) => {
    setDonationFrequency(event.target.value);
  };

  const handleAmountChange = (event) => {
    const check = document.getElementById("form-3-percent");
    if (check.checked) {
      check.checked = false;
    }
    const newAmount = event.target.value;
    setDonationAmount(newAmount);
    setProcessingFee(0);
    setSelectedAmount(event.target.value);
    setCustomAmount("");
  };

  const handleCustomAmountChange = (event) => {
    const check = document.getElementById("form-3-percent");
    if (check.checked) {
      check.checked = false;
    }
    const newAmount = event.target.value.replace(/\D/g, "");
    setDonationAmount(newAmount);
    setProcessingFee(0);
    setSelectedAmount(null);
    setCustomAmount(newAmount);
  };

  const handleAreaChange = (event) => {
    setDonationArea(event.target.value);
  };

  const handleDropdownOn = () => {
    setDropdown(true);
  };

  const handleDropdownOff = () => {
    setDropdown(false);
  };

  const handleProcessingFee = (event) => {
    if (event.target.checked) {
      const temp = (3 * parseFloat(donationAmount)) / 100;
      setProcessingFee(temp);
    } else {
      setProcessingFee(0);
    }
  };

  const donamt = { donationAmount };
  const profee = { processingFee };
  const donateAmount = parseFloat(donamt.donationAmount);
  const processFee = parseFloat(profee.processingFee);

  const totalAmount = isNaN(donateAmount + processFee)
    ? 0
    : donateAmount + processFee;

  const handlePay = async () => {
    try {
      const amt = parseFloat(donationAmount);
      if (!amt || amt <= 0) {
        alert("Please select or enter a valid donation amount.");
        return;
      }
      if (donationFrequency === "---") {
        alert("Please choose a donation frequency.");
        return;
      }
      if (donationArea === "---") {
        alert("Please pick a donation area.");
        return;
      }

      const firstName = document
        .getElementById("form-donate-first-name")
        ?.value?.trim();
      const lastName = document
        .getElementById("form-donate-last-name")
        ?.value?.trim();
      const email = document.getElementById("form-donate-email")?.value?.trim();
      const country = document
        .getElementById("form-donate-country")
        ?.value?.trim();
      const state = document.getElementById("form-donate-state")?.value?.trim();
      const city = document.getElementById("form-donate-city")?.value?.trim();
      const address1 = document
        .getElementById("form-donate-address")
        ?.value?.trim();
      const zipCode = document.getElementById("form-donate-pin")?.value?.trim();
      const phone = document
        .getElementById("form-donate-mobile")
        ?.value?.trim();
      const panValue = document
        .getElementById("form-donate-pan")
        ?.value?.trim();

      if (!firstName || !email) {
        alert("Please enter at least your first name and email.");
        return;
      }
      if (error) {
        alert(error);
        return;
      }

      const total = Number.isFinite(amt + Number(processingFee))
        ? amt + Number(processingFee)
        : amt;

      const payload = {
        donation: {
          frequency: donationFrequency,
          area: donationArea,
          amount: amt,
          processingFee: Number(processingFee) || 0,
          totalAmount: Number(total.toFixed(2)),
          currency: "INR",
          paymentSource: "WEB",
        },
        billingDetails: {
          firstName,
          lastName,
          phone,
          email,
          pan: panValue,
          address: {
            address1,
            city,
            state,
            country,
            zipCode,
          },
        },
      };

      const res = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/api/payments/create`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        }
      );

      const data = await res.json();

      if (!res.ok) {
        throw new Error(data.error || "Failed to create payment entry");
      }

      // alert(`Donation entry stored! Transaction ID: ${data.transactionId}`);

      openRazorpayCheckout(data);
    } catch (e) {
      console.error(e);
      alert(e?.message || "Something went wrong while submitting donation.");
    }
  };

  const openRazorpayCheckout = (apiResponse) => {
    const { transactionId, entry, razorpayKeyId } = apiResponse;

    const options = {
      key: razorpayKeyId,
      amount: Number(entry.amount) * 100,
      currency: "INR",
      name: "Lokarpan",
      description: `Donation - ${entry.donationArea}`,
      order_id: entry.razorpayOrderId ? entry.razorpayOrderId : null,
      subscription_id: entry.razorpaySubscriptionId ? entry.razorpaySubscriptionId : null,
      prefill: {
        name: `${entry.firstName} ${entry.lastName}`,
        email: entry.email,
        contact: entry.phone,
      },
      handler: async function (response) {
        await fetch(
          `${process.env.REACT_APP_API_BASE_URL}/api/payments/verify`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              transactionId,
              razorpay_payment_id: response.razorpay_payment_id,
              razorpay_order_id: response.razorpay_order_id ? response.razorpay_order_id : null,
              razorpay_subscription_id: response.razorpay_subscription_id ? response.razorpay_subscription_id : null,
              razorpay_signature: response.razorpay_signature,
            }),
          }
        );
        toast.success(
          `Rs. ${entry.amount} paid successfully. Thank you for your donation!`
        );

        // Reset form fields
        document.getElementById("form-donate-first-name").value = "";
        document.getElementById("form-donate-last-name").value = "";
        document.getElementById("form-donate-email").value = "";
        document.getElementById("form-donate-country").value = "";
        document.getElementById("form-donate-state").value = "";
        document.getElementById("form-donate-city").value = "";
        document.getElementById("form-donate-address").value = "";
        document.getElementById("form-donate-pin").value = "";
        document.getElementById("form-donate-mobile").value = "";
        document.getElementById("form-donate-pan").value = "";

        // Reset state variables
        setDonationAmount("---");
        setDonationArea("---");
        setProcessingFee("---");
        setPAN("");
        setCustomAmount("");
        setSelectedAmount(null);
        setDonationFrequency("Once");

        // Uncheck checkboxes
        document.getElementById("form-3-percent").checked = false;
      },
      modal: {
        ondismiss: function () {
          toast.info("Payment popup closed. No payment was made.");
        },
      },
      theme: {
        color: "#3399cc",
      },
    };

    const rzp = new window.Razorpay(options);

    rzp.on("payment.failed", async function (response) {
      toast.error(
        `Payment failed: ${response.error.description || "Please try again."}`
      );
      await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/api/payments/failure`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            transactionId,
          }),
        }
      );
    });

    rzp.open();
  };

  return (
    <>
      <Navbar />
      <AppleLocalNav title="Donate" overview="/donate" overviewLabel="Donate" pages={[{ label: "FAQ", to: "/faqs" }]} />
      <div className="donate-head">
        <h1>Invest in the Future of India</h1>
        <h1>
          Your contributions make an immediate difference in classrooms,
          fostering a lasting impact on rural education for years to come.
        </h1>
        <div className="citizen-dropdown">
          <div className="citizen-dropdown-inner">
            <input
              type="checkbox"
              id="donate-hyperlink"
              name="donate-hyperlink"
              className="input-d"
            />
            <label htmlFor="donate-hyperlink" className="drop-content">
              Non Indian Citizens
            </label>
            <div className="ans-sec donate-ans-sec">
              <p className="answer">
                {" "}
                If you are a non-resident Indian or a foreign national residing
                outside of India, please consult our FAQs to learn how you can
                make a donation.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="donate-page">
        <div className="donate-form">
          <form action="" method="get">
            <div className="donate-form-inner">
              <div
                id="donate-section-1"
                className={`donate-part ${currentStep === 0 ? `active slide-${slideDirection}` : "hidden"}`}
              >
                <div className="page-marker">01/06</div>
                <fieldset>
                  <legend className="donate-form-sec-title">
                    How frequently would you like to give?
                  </legend>
                  <div role="radiogroup" className="grid">
                    <input
                      type="radio"
                      name="form-donate-frequency"
                      id="form-donate-frequency-once"
                      className="radio-hidden text-input1"
                      value={"Once"}
                      onClick={handleFrequencyChange}
                    />
                    <label
                      className="radio-label frequency"
                      htmlFor="form-donate-frequency-once"
                    >
                      Once
                    </label>
                    <input
                      type="radio"
                      name="form-donate-frequency"
                      id="form-donate-frequency-monthly"
                      className="radio-hidden"
                      value={"Monthly"}
                      onClick={handleFrequencyChange}
                    />
                    <label
                      className="radio-label  frequency"
                      htmlFor="form-donate-frequency-monthly"
                    >
                      Monthly
                    </label>
                  </div>
                </fieldset>
                <StepNavigation showBack={false} showNext={true} />
              </div>
              <div
                id="donate-section-2"
                className={`donate-part ${currentStep === 1 ? `active slide-${slideDirection}` : "hidden"}`}
              >
                <div className="page-marker">02/06</div>
                <fieldset>
                  <legend className="donate-form-sec-title">
                    How much would you like to donate?
                  </legend>
                  <div role="radiogroup" className="grid">
                    <input
                      type="radio"
                      name="form-donate-amount"
                      id="form-donate-amount-1000"
                      className="radio-hidden"
                      value={1000}
                      checked={selectedAmount === "1000"}
                      onClick={handleAmountChange}
                    />
                    <label
                      className="radio-label  amount"
                      htmlFor="form-donate-amount-1000"
                    >
                      ₹1,000
                    </label>
                    <input
                      type="radio"
                      name="form-donate-amount"
                      id="form-donate-amount-5000"
                      className="radio-hidden"
                      value={5000}
                      checked={selectedAmount === "5000"}
                      onClick={handleAmountChange}
                    />
                    <label
                      className="radio-label amount"
                      htmlFor="form-donate-amount-5000"
                    >
                      ₹5,000
                    </label>
                    <input
                      type="radio"
                      name="form-donate-amount"
                      id="form-donate-amount-8000"
                      className="radio-hidden"
                      value={8000}
                      checked={selectedAmount === "8000"}
                      onClick={handleAmountChange}
                    />
                    <label
                      className="radio-label amount"
                      htmlFor="form-donate-amount-8000"
                    >
                      ₹8,000
                    </label>
                    <input
                      type="radio"
                      name="form-donate-amount"
                      id="form-donate-amount-10000"
                      className="radio-hidden"
                      value={10000}
                      checked={selectedAmount === "10000"}
                      onClick={handleAmountChange}
                    />
                    <label
                      className="radio-label amount"
                      htmlFor="form-donate-amount-10000"
                    >
                      ₹10,000
                    </label>
                    <input
                      type="radio"
                      name="form-donate-amount"
                      id="form-donate-amount-30000"
                      className="radio-hidden"
                      value={30000}
                      checked={selectedAmount === "30000"}
                      onClick={handleAmountChange}
                    />
                    <label
                      className="radio-label amount"
                      htmlFor="form-donate-amount-30000"
                    >
                      ₹30,000
                    </label>
                    <input
                      className="labelless-input text-input1 radio-label amount"
                      placeholder="Enter Amount"
                      name="form-donate-amount"
                      value={customAmount}
                      id="form-donate-amount-custom"
                      onChange={handleCustomAmountChange}
                    />
                  </div>
                </fieldset>
                <StepNavigation showBack={true} showNext={true} />
              </div>
              <div
                id="donate-section-3"
                className={`donate-part ${currentStep === 2 ? `active slide-${slideDirection}` : "hidden"}`}
              >
                <div className="page-marker">03/06</div>
                <fieldset>
                  <legend className="donate-form-sec-title">
                    Which fund would you prefer to support with your donation?
                  </legend>
                  <div role="radiogroup" className="grid">
                    <input
                      type="radio"
                      name="form-donate-towards"
                      id="form-donate-towards-problems"
                      className="radio-hidden"
                      value="Must Solve problems"
                      onClick={handleAreaChange}
                    />
                    <label
                      className="radio-label-with-img"
                      htmlFor="form-donate-towards-problems"
                    >
                      <img
                        className="radio-label-with-img-img"
                        src="https://www.colorhexa.com/ebebeb.png"
                        alt=""
                      />
                      <span className="radio-label-with-img-text">
                        Education
                      </span>
                    </label>
                    <input
                      type="radio"
                      name="form-donate-towards"
                      id="form-donate-towards-frontiers"
                      className="radio-hidden"
                      value="Frontiers: HIV & Sickle Cell Disease"
                      onClick={handleAreaChange}
                    />
                    <label
                      className="radio-label-with-img"
                      htmlFor="form-donate-towards-frontiers"
                    >
                      <img
                        className="radio-label-with-img-img"
                        src="https://www.colorhexa.com/ebebeb.png"
                        alt=""
                      />
                      <span className="radio-label-with-img-text">
                        Health and Nutrition
                      </span>
                    </label>
                    <input
                      type="radio"
                      name="form-donate-towards"
                      id="form-donate-towards-empower"
                      className="radio-hidden"
                      value="Empowerment & Opportunity"
                      onClick={handleAreaChange}
                    />
                    <label
                      className="radio-label-with-img"
                      htmlFor="form-donate-towards-empower"
                    >
                      <img
                        className="radio-label-with-img-img"
                        src="https://www.colorhexa.com/ebebeb.png"
                        alt=""
                      />
                      <span className="radio-label-with-img-text">
                        Livelihoods
                      </span>
                    </label>
                    <input
                      type="radio"
                      name="form-donate-towards"
                      id="form-donate-towards-environment"
                      className="radio-hidden"
                      value="Environmental Sustainability"
                      onClick={handleAreaChange}
                    />
                    <label
                      className="radio-label-with-img"
                      htmlFor="form-donate-towards-environment"
                    >
                      <img
                        className="radio-label-with-img-img"
                        src="https://www.colorhexa.com/ebebeb.png"
                        alt=""
                      />
                      <span className="radio-label-with-img-text">
                        Environment
                      </span>
                    </label>
                  </div>
                </fieldset>
                <StepNavigation showBack={true} showNext={true} />
              </div>
              <div
                id="donate-section-4"
                className={`donate-part ${currentStep === 3 ? `active slide-${slideDirection}` : "hidden"}`}
              >
                <div className="page-marker">04/06</div>
                <fieldset>
                  <legend className="donate-form-sec-title">
                    Your Personal Details
                  </legend>
                  <div className="grid">
                    <label
                      className="input-label long"
                      htmlFor="form-donate-first-name"
                    >
                      First Name <br />
                      <input
                        className="text-input"
                        type="text"
                        name="donate-form-first-name"
                        id="form-donate-first-name"
                      />
                    </label>
                    <label
                      className="input-label long"
                      htmlFor="form-donate-last-name"
                    >
                      Last Name <br />
                      <input
                        className="text-input"
                        type="text"
                        name="donate-form-last-name"
                        id="form-donate-last-name"
                      />
                    </label>
                    <label
                      className="input-label long"
                      htmlFor="form-donate-email"
                    >
                      Email Address <br />
                      <input
                        className="text-input"
                        type="text"
                        name="donate-form-email"
                        id="form-donate-email"
                      />
                    </label>
                    <label
                      className="input-label long  text-input"
                      htmlFor="form-donate-country"
                    >
                      Country of Residence <br />
                      {/* <input
                        type="text"
                        name="donate-form-country"
                        id="form-donate-country"
                      /> */}
                      <select
                        className="long1"
                        id="form-donate-country"
                        name="donate-form-country"
                      >
                        <option value="">Select Country</option>
                      </select>
                    </label>
                  </div>
                </fieldset>
                <StepNavigation showBack={true} showNext={true} />
              </div>
              <div
                id="donate-section-5"
                className={`donate-part ${currentStep === 4 ? `active slide-${slideDirection}` : "hidden"}`}
              >
                <div className="page-marker">05/06</div>
                <fieldset>
                  <legend className="donate-form-sec-title">
                    Your Billing address
                  </legend>
                  <div className="grid">
                    <label
                      className="input-label long"
                      htmlFor="form-donate-state"
                    >
                      State <br />
                      <input
                        className="text-input"
                        type="text"
                        name="donate-form-state"
                        id="form-donate-state"
                        placeholder="State"
                      />
                    </label>
                    <label
                      className="input-label long"
                      htmlFor="form-donate-city"
                    >
                      City/Town <br />
                      <input
                        className="text-input"
                        type="text"
                        name="donate-form-city"
                        id="form-donate-city"
                        placeholder="City"
                      />
                    </label>
                    <label
                      className="input-label long"
                      htmlFor="form-donate-address"
                    >
                      Address <br />
                      <input
                        className="text-input"
                        type="text"
                        name="donate-form-address"
                        id="form-donate-address"
                        placeholder="Address"
                      />
                    </label>
                    <label
                      className="input-label long"
                      htmlFor="form-donate-pin"
                    >
                      Postal/ Zip Code
                      <br />
                      <input
                        className="text-input"
                        type="text"
                        name="donate-form-pin"
                        id="form-donate-pin"
                        placeholder="Pin-Code"
                      />
                    </label>
                    <label
                      className="input-label long"
                      htmlFor="form-donate-mobile"
                    >
                      Mobile <br />
                      <input
                        className="text-input"
                        type="text"
                        name="donate-form-mobile"
                        id="form-donate-mobile"
                        placeholder="+xx xxxxxxxxxx"
                      />
                    </label>
                    <label
                      className="input-label long"
                      htmlFor="form-donate-pan"
                    >
                      PAN Number <br />
                      <input
                        className="text-input"
                        type="text"
                        name="donate-form-pan"
                        id="form-donate-pan"
                        value={pan}
                        placeholder="ABCDE1234A"
                        onChange={(e) => setPAN(e.target.value)}
                        onBlur={validatePAN}
                        // maxLength={10}
                      />
                      <div
                        style={{
                          position: "absolute",
                          color: "red",
                          paddingLeft: "10px",
                          fontSize: "16px",
                        }}
                      >
                        {error}
                      </div>
                    </label>
                  </div>
                </fieldset>
                <StepNavigation showBack={true} showNext={true} />
              </div>
              <div
                id="donate-section-6"
                className={`donate-part ${currentStep === 5 ? `active slide-${slideDirection}` : "hidden"}`}
              >
                <div className="page-marker">06/06</div>
                <fieldset>
                  <div className="donate-form-sec-title">
                    <p className="recap">Donation Recap</p>
                  </div>
                  <hr />
                  <div className="donate-recap-sections">
                    <div className="donate-recap-section">
                      <div>
                        <p className="recap">Donation Type </p>
                        <div className="donation-recap-link" onClick={() => setCurrentStep(0)}>Edit</div>
                      </div>
                      <div>{donationFrequency}</div>
                    </div>
                    <div className="donate-recap-section">
                      <div>
                        <p className="recap">Donation Area</p>
                        <div className="donation-recap-link" onClick={() => setCurrentStep(2)}>Edit</div>
                      </div>
                      <div>{donationArea}</div>
                    </div>
                  </div>
                  <hr />
                  <div className="donate-recap-sections">
                    <div className="donate-recap-section">
                      <div>
                        <p className="recap">Donation Amount</p>
                        <div className="donation-recap-link" onClick={() => setCurrentStep(1)}>Edit</div>
                      </div>
                      <div>{`₹ ${donationAmount}`}</div>
                    </div>
                    <div className="donate-recap-section">
                      <label htmlFor="form-3-percent">
                        <input
                          type="checkbox"
                          onClick={handleProcessingFee}
                          name=""
                          id="form-3-percent"
                        />
                        Add 3% to cover the credit card processing fee
                      </label>
                      {/* <label htmlFor="newsletter-subscription">
                        <input
                          type="checkbox"
                          name=""
                          id="newsletter-subscription"
                        />
                        Subscribe to our newsletter?
                      </label> */}
                    </div>
                  </div>
                  <hr />
                  <div className="donate-recap-sections">
                    <div className="donate-recap-section">
                      <p className="recap">Credit Card Processing fee</p>
                      <p>{`₹ ${processingFee}`}</p>
                      <p className="recap">Total payment amount</p>
                      <p>{`₹ ${totalAmount}`}</p>
                    </div>
                  </div>
                  <hr />
                </fieldset>
                <StepNavigation showBack={true} />
                <div>
                  <div className="donate-submit-section">
                    <div className="apply-btn transparent donate-apply-btn">
                      <div
                        className="apply-btn-text-black body-btn"
                        onClick={handlePay}
                      >
                        Submit & Enter Payment Details
                      </div>
                    </div>
                    <p>
                      By submitting your information and making your gift, you
                      agree to the Lokarpan
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Donate;
